import { useMemo } from "react";
import { NumberFormatter } from "./useNumberFormatter";

export const INFINITE_FRACTION_DIGITS: unique symbol = Symbol("infiniteFractionDigits");

export type MaximumFractionDigits = number | typeof INFINITE_FRACTION_DIGITS;

export type UseCurrencyFormatterOptions = {
	culture: string;
	currency: string;
	maximumFractionDigits?: MaximumFractionDigits;
};

export function useCurrencyFormatter(
	options: UseCurrencyFormatterOptions
): NumberFormatter {
	const {
		culture,
		currency,
		maximumFractionDigits
	} = options;

	const formatter = useMemo(
		(): Intl.NumberFormat => new Intl.NumberFormat(
			culture,
			{
				style: "currency",
				currency,
				maximumFractionDigits: maximumFractionDigits === INFINITE_FRACTION_DIGITS
					? INTL_MAXIMUM_FRACTION_DIGITS
					: maximumFractionDigits
			} satisfies Intl.NumberFormatOptions
		),
		[
			culture,
			currency,
			maximumFractionDigits
		]
	);

	return useMemo(
		(): NumberFormatter => (value: number): string => formatter.format(value),
		[formatter]
	);
}

const INTL_MAXIMUM_FRACTION_DIGITS = 20;
